<!--video配置页面-->
<template>
	<treeBody>
		<!--左边tree插件-->
		<unitTree @checkItem='checkItem' slot="tree" :getTreeStyle='getTreeStyle(false)'></unitTree>
		<!--右边-->
		<div class="monreportRigth" slot="body">
			<div class="rigth">
				<div class="buttonLine">
					<!--按钮-->
					<iconButton @buttonClick='addVideo' buttonText='添加' icoName="wedoButton/add.png"></iconButton>
					<iconButton @buttonClick='deleteVideo' buttonText='删除' icoName="wedoButton/delete.png"></iconButton>
					<iconButton @buttonClick='editVideo' buttonText='编辑' icoName="wedoButton/edit.png"></iconButton>
					<iconButton @buttonClick='getInfoList(nowUnit)' buttonText='刷新' icoName="wedoButton/edit.png"></iconButton>
					<iconButton @buttonClick='bindArchives' buttonText='绑定台账设备' icoName="wedoButton/edit.png"></iconButton>
					<iconButton @buttonClick='unbingArchvies' buttonText='解除绑定' icoName="wedoButton/edit.png"></iconButton>
				</div>
				<!--展示列表插件-->
				<infoList ref="infoList" @checkItem="nowVideoConfig = $event" style="height: calc(100% - 50px);" :columns='columns' 
				:dataList="showVideoConfigList" @selectPage='nowIndex = $event' :pageLen='20' :fillAll="true" :totalSize="videoConfigList.length"></infoList>
			</div>
		</div>
	</treeBody>
</template>

<script type="text/javascript">
	//body组件（左面树右边list）
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	//tree组件
	import unitTree from '@/components/module/tree/unitTree.vue'
	//list组件
	import infoList from '@/components/module/universal/infoList.vue'
	//按钮组件
	import iconButton from '@/components/module/universal/iconButton.vue'
	//弹窗使用inputDialog组件
	import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
	//弹窗使用的tree组件
	import treeDialog from '@/components/module/dialog/treeDialog.vue'
	export default {
		components: {
			unitTree,
			treeBody,
			infoList,
			iconButton,
			nomalInputDialog,
		},
		props: [],
		data() {
			return {
				nowUnit: undefined, //当前单位
				nowVideoConfig: undefined, //当前设备
				videoConfigList: [], //设备列表
				videoConfigListLastSort: 0, //设备列表的sort+1，新增时用到
				nowIndex:0,
				columns: [{
					name: "名称",
					key: "deviceName"
				}, {
					name: "IP",
					key: "ip",
				}, {
					name: "端口",
					key: "port",
				}, {
					name: "用户名",
					key: "userName",
				}, {
					name: "密码",
					key: "password",
				}, {
					name: "类型",
					key: "type",
					//					weight: 1.5
				}, {
					name: "视频路径",
					key: "videoUrl",
					weight: 2
				}]
			}
		},
		created() {
			debugPage = this
		},
		mounted() {},
		destroyed() {},
		computed: {
			showVideoConfigList(){
				var datas = this.videoConfigList
				var index = this.nowIndex*20
				var limit = index+20
				return datas.filter((d,i)=>{
					return   i<limit && i>=index
				})
			},
			getColorById() {
				return id => {
					return this.$store.resourcesStore.getters.getColorById(id)
				}
			},
			getTreeStyle() {
				return bg=>{
					if(bg){
						return {
						'color': this.getColorById('fontColor'),
						'background-color': this.getColorById('secondMenuBG'),
						}
					}else{
						return {
						'color': this.getColorById('fontColor'),
						}
					}
					
				} 
			},
		},
		watch: {
			//监控nowUnit，如果有变化即刷新list
			nowUnit(nv, ov) {
				if(undefined != nv) {
					this.getInfoList(nv)
				}
			}
		},
		methods: {
			//点击事件
			checkItem(item) {
				this.nowUnit = item
				//切换单位进行清理
				this.nowVideoConfig = undefined
				this.$refs.infoList.nowCheckIndex = -1
			},
			//获取当前页面展示list
			getInfoList(unit) {
				this.$api.videoApi.searchByUnitId(unit.id, respon => {
					if(respon.length == 0) {
						this.videoConfigList = []
						return
					}
					this.videoConfigList = respon
					this.videoConfigListLastSort = respon[respon.length - 1].sort + 1
				}, respon => {
					this.$dialogMethod.showMessage(respon)
				})
			},

			//增
			addVideo() {
				//使用全局方法  this.$dialogMethod.createDialog
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('添加设备', [{
					name: '名称',
					pkid: 'deviceName',
				}, {
					name: 'IP',
					pkid: 'ip',
				}, {
					name: '端口',
					pkid: 'port',
					type: '2',
				}, {
					name: '用户名',
					pkid: 'username',
				}, {
					name: '密码',
					pkid: 'password',
				}, {
					name: '视频路径',
					pkid: 'videoUrl',
				}, {
					name: '类型',
					pkid: 'type',
					type: '7',
					nameKey: "text",
					dataList: [{
						"text": "海康威视",
						"value": "HIKVISION"
					}]
				}], item => {
					if(isempty(item.deviceName)){
						this.$dialogMethod.showMessage('请输入设备名称')
						return false
					}
					//添加接口
					var typeValue =  item.type?item.type.value:''
					this.$api.videoApi.createDevice(this.nowUnit.id, item.deviceName, item.ip, item.port, item.username, item.password,typeValue , item.videoUrl, this.videoConfigListLastSort, respon => {
						this.$dialogMethod.showMessage("添加成功!")
						this.videoConfigList.push(respon)
					})
				})
			},

			//删
			deleteVideo() {
				if(this.nowVideoConfig == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的设备!")
					return
				}
				this.$dialogMethod.openAgreeDialog("删除设备", "是否删除 " + this.nowVideoConfig.deviceName, () => {
					//删除接口
					this.$api.videoApi.deleteDevice(this.nowVideoConfig.pkid, this.nowUnit.id, respon => {
						this.$dialogMethod.showMessage("删除成功!")
						this.videoConfigList = this.videoConfigList.filter(item => {
							return item.pkid != this.nowVideoConfig.pkid
						})
						this.nowVideoConfig = undefined
						this.$refs.infoList.nowCheckIndex = -1
					})
				})
			},

			//修改
			editVideo() {
				if(this.nowVideoConfig == undefined) {
					this.$dialogMethod.showMessage("请先选中要编辑的设备!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('编辑设备', [{
					name: '名称',
					pkid: 'deviceName',
					defaultValue: this.nowVideoConfig.deviceName
				}, {
					name: 'IP',
					pkid: 'ip',
					defaultValue: this.nowVideoConfig.ip
				}, {
					name: '端口',
					pkid: 'port',
					type: '2',
					defaultValue: this.nowVideoConfig.port
				}, {
					name: '用户名',
					pkid: 'username',
					defaultValue: this.nowVideoConfig.userName
				}, {
					name: '密码',
					pkid: 'password',
					defaultValue: this.nowVideoConfig.password
				}, {
					name: '视频路径',
					pkid: 'videoUrl',
					defaultValue: this.nowVideoConfig.videoUrl
				}, {
					name: '类型',
					pkid: 'type',
					type: '7',
					nameKey: "text",
					dataList: [{
						"text": "海康威视",
						"value": "HIKVISION"
					}],
					defaultValue: this.nowVideoConfig.type
				}], item => {
					//修改接口
					this.$api.videoApi.editDevice(this.nowVideoConfig.pkid, item.deviceName, item.ip, item.port, item.username, item.password, item.type.value, item.videoUrl, this.nowVideoConfig.sort, respon => {
						this.$dialogMethod.showMessage("更新设备成功!")
						var videoConfig = this.videoConfigList.find(vc => {
							return vc.pkid == this.nowVideoConfig.pkid
						})
						videoConfig.deviceName = item.deviceName
						videoConfig.ip = item.ip
						videoConfig.port = item.port
						videoConfig.userName = item.username
						videoConfig.password = item.password
						videoConfig.type = item.type.value
						videoConfig.videoUrl = item.videoUrl
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			//绑定台账设备
			bindArchives() {
				if(this.nowVideoConfig == undefined) {
					this.$dialogMethod.showMessage("请先选择video!")
					return
				}
				this.$api.videoApi.findRelation(this.nowVideoConfig.pkid, "archives", respon => {
					var checkitem = ''
					if(!isempty(respon)) {
						checkitem = respon[0]
					}
					var dialog = this.$dialogMethod.createDialog(treeDialog)
					dialog.open("绑定台账设备", checkitem, item => {
						if(item.entityName != "AppEquipmentArchives") {
							this.$dialogMethod.showMessage("请选择要绑定的设备!")
							return false
						}
						if(checkitem != '') {
							//如果当前设备已经绑定先解除绑定
							this.$api.videoApi.unbingArchvies(checkitem.pkid, respon => {
								this.bindingArchive(item)
							}, respon => {
								this.$dialogMethod.showMessage(respon)
							})
						} else {
							this.bindingArchive(item)
						}
					})
				}, respon => {
					this.$dialogMethod.showMessage(respon)
				})
			},
			//绑定api
			bindingArchive(item) {
				this.$api.videoApi.bindArchives(this.nowVideoConfig.pkid, item.id, respon => {
					this.$dialogMethod.showMessage("绑定成功!")
				}, respon => {
					this.$dialogMethod.showMessage(respon)
				})
			},
			//解除绑定设备
			unbingArchvies() {
				if(this.nowVideoConfig == undefined) {
					this.$dialogMethod.showMessage("请先选择video!")
					return
				}
				this.$api.videoApi.findRelation(this.nowVideoConfig.pkid, "archives", respon => {
					if(isempty(respon)) {
						this.$dialogMethod.showMessage("当前video未绑定台账设备!")
						return
					}
					this.$api.videoApi.unbingArchvies(respon[0].pkid, respon => {
						this.$dialogMethod.showMessage("解除绑定成功!")
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				}, respon => {
					this.$dialogMethod.showMessage(respon)
				})
			}
		}
	}
</script>

<style scoped>
	.rigth {
		float: left;
		height: 100%;
		width: 100%;
	}
	
	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	
	.entityTree {
		float: left;
		width: 2rem;
	}
</style>
